import { newcomerSteps } from "@/mocks/comicHelp";

export default function Beginner() {
  return (
    <section id="beginner" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="container-x">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-900">
            <i className="ri-rocket-line"></i>
            新手入门
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">
            四步开启追漫之旅
          </h2>
          <p className="mt-3 max-w-2xl text-base leading-relaxed text-foreground-700">
            从注册登录到顺畅阅读，掌握这几个核心操作，就能轻松用好笔笔漫画网的全部基础功能。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {newcomerSteps.map((s, i) => (
            <div
              key={s.title}
              className="relative rounded-2xl border border-background-200 bg-background-50 p-6 transition-transform hover:-translate-y-1"
            >
              <span className="absolute right-5 top-4 font-heading text-4xl text-background-300">0{i + 1}</span>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary-100 text-secondary-900">
                <i className={`${s.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-5 text-lg font-semibold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}